import { Placement } from "@popperjs/core";
import React from "react";

import { HexTooltip } from "../../../../hex-components";

export const MENTION_TOOLTIP_WIDTH = 280;
const MENTION_TOOLTIP_MIN_WIDTH = 200;
const MENTION_TOOLTIP_MAX_WIDTH = 400;

interface MentionTooltipProps {
  children: React.ReactNode;
  content: React.ReactNode;
  placement?: Placement;
  maxWidthOverride?: number;
  disabled?: boolean;
}

/**
 * Standardized tooltip component for mention details.
 * Provides consistent sizing and behavior across all mention types.
 */
export const MentionTooltip = React.memo(function MentionTooltip({
  children,
  content,
  disabled = false,
  maxWidthOverride,
  placement = "right",
}: MentionTooltipProps) {
  const effectiveWidth = maxWidthOverride ?? MENTION_TOOLTIP_WIDTH;
  const clampedWidth = Math.min(
    Math.max(effectiveWidth, MENTION_TOOLTIP_MIN_WIDTH),
    MENTION_TOOLTIP_MAX_WIDTH,
  );

  return (
    <HexTooltip
      content={content}
      disabled={disabled || !content}
      hoverCloseDelay={200}
      interactionKind="hover"
      maxWidthOverride={clampedWidth}
      placement={placement}
    >
      {children}
    </HexTooltip>
  );
});
